import { UpdatePassword } from "../../components/UpdatePassword/UpdatePassword"

export const PasswordUpdate =()=>{
    return(
        <div>
            <UpdatePassword />
        </div>
    )
}
